export default {
  pass: 'Passed',
  fail: 'Not Passed',
};
